import {Injectable} from "@angular/core";
import {User} from "../model/User";
import {Role} from '../model/Role';

@Injectable({providedIn: 'root'})
export class UserRoleProviderService {
  private user : User = {
    roles: []
  };

  private readonly roleToTokenMap: Partial<Record<Role, string[]>> = {
    [Role.station_info_view]: ['station-info-view', 'station_info_view'],
    [Role.station_info_edit]: ['station-info-edit', 'station_info_edit'],
    [Role.station_info_delete]: ['station-info-delete', 'station_info_delete'],
  };

  public setUserRoles(roles: string[]): void {
    this.user.roles = roles;
  }

  public hasRequiredRole(requiredRole: Role): boolean {
    const fallbackRole = Role[requiredRole];
    const tokenRoles = this.roleToTokenMap[requiredRole] ?? [fallbackRole];
    return tokenRoles.some(role => this.user.roles.includes(role));
  }
}
